module.exports = __webpack_public_path__ + "static/img/title-block-bg.7440459.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mall/title-block-bg.png
// module id = VvnX
// module chunks = 215